/**
 * Plan content display type is used to determine how we should display the given context
 */ export var ContextDisplayType = /*#__PURE__*/ function(ContextDisplayType) {
    ContextDisplayType["TeamsTab"] = "teamsTab";
    ContextDisplayType["SharePointPage"] = "sharePointPage";
    ContextDisplayType["MeetingNotes"] = "meetingNotes";
    ContextDisplayType["LoopPage"] = "loopPage";
    ContextDisplayType["Other"] = "other";
    return ContextDisplayType;
}({});
